/**
 * @generated SignedSource<<2f9081c18d21fd1b77bdaafd0819df14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiveWidgetEditionEnum = "ASIA" | "HK" | "INT" | "%future added value";
export type homePageQuery$variables = {
  applicationId: string;
  chinaFutureTechSectionEntityId: string;
  chinaFutureTechStoryPackageArticlesQueueName: string;
  commentHarrySectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  commentQueueName: string;
  dailyPulseTypeUuId: string;
  focusQueueName: string;
  highlightQueueName: string;
  latestExcludeArticleTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  latestExcludeSectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  liveWidgetEditionEnumValue: LiveWidgetEditionEnum;
  morningStudioQueueName: string;
  plusNewsAgendaEndDate: number;
  plusNewsAgendaStartDate: number;
  plusNewsAgendaTypes: ReadonlyArray<string | null | undefined>;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  scmpShortsQueueName: string;
  secondaryStoryPackageArticlesQueueName: string;
  seriesWidgetArticlesQueueName: string;
  spotlightQueueName: string;
  storyPackageArticlesQueueName: string;
  topStoriesQueueName: string;
};
export type homePageQuery$data = {
  readonly commentQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly morningStudioQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2PickMorningStudioArticle" | "hooksPickMorningStudioArticle">;
  } | null | undefined;
  readonly secondaryStoryPackageArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly spotlightQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly storyPackageArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly topStories: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"heroArticleArticle" | "heroArticlesHomeV2Content">;
        };
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge" | "heroArticleThreeArticleIds" | "heroSecondaryArticlesHomeV2QueueItemsEdge" | "heroThreeArticlesQueueItemsEdge" | "topStoriesHomeV2QueueItemsEdge" | "topStoriesQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"chinaFutureTechStoryPackageHomeV2Query" | "chinaFutureTechStoryPackageQuery" | "chinaScienceDiscoveryWidgetQuery" | "commentQueueQuery" | "flexiUnitHomeV2QueueQuery" | "focusArticleHomeFocusArticleQuery" | "hooksPlusWidgetConfigQuery" | "hooksPremiumNativeAdConfigQuery" | "latestContentsHomeV2Query" | "latestContentsQuery" | "opinionHomeV2QueueQuery" | "plusWidgetHomeV2Query" | "plusWidgetQuery" | "scmpShortsHomeV2Query" | "secondaryStoryPackageHomeV2Query" | "secondaryStoryPackageQuery" | "seriesWidgetHomeV2Query" | "seriesWidgetQuery" | "spotlightHomeV2Query" | "spotlightQuery" | "storyPackageQuery" | "superSplashHomeV2Query" | "superSplashQuery" | "thingsToDoHomeV2Query" | "thingsToDoQueue">;
};
export type homePageQuery = {
  response: homePageQuery$data;
  variables: homePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chinaFutureTechSectionEntityId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chinaFutureTechStoryPackageArticlesQueueName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentHarrySectionIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueName"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dailyPulseTypeUuId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "focusQueueName"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "highlightQueueName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "latestExcludeArticleTypes"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "latestExcludeSectionIds"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "liveWidgetEditionEnumValue"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "morningStudioQueueName"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaEndDate"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaStartDate"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaTypes"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpShortsQueueName"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "secondaryStoryPackageArticlesQueueName"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seriesWidgetArticlesQueueName"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spotlightQueueName"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageArticlesQueueName"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topStoriesQueueName"
},
v22 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "topStoriesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 18
  }
],
v24 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "topStoriesQueueItemsEdge"
},
v25 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge"
},
v26 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "morningStudioQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9
  }
],
v28 = {
  "kind": "Variable",
  "name": "scmpPlusPaywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v29 = [
  {
    "kind": "Variable",
    "name": "latestExcludeArticleTypes",
    "variableName": "latestExcludeArticleTypes"
  },
  {
    "kind": "Variable",
    "name": "latestExcludeSectionIds",
    "variableName": "latestExcludeSectionIds"
  },
  (v28/*: any*/)
],
v30 = [
  {
    "kind": "Variable",
    "name": "commentHarrySectionIds",
    "variableName": "commentHarrySectionIds"
  },
  {
    "kind": "Variable",
    "name": "commentQueueName",
    "variableName": "commentQueueName"
  },
  (v28/*: any*/)
],
v31 = [
  {
    "kind": "Variable",
    "name": "secondaryStoryPackageArticlesQueueName",
    "variableName": "secondaryStoryPackageArticlesQueueName"
  }
],
v32 = [
  {
    "kind": "Variable",
    "name": "seriesWidgetArticlesQueueName",
    "variableName": "seriesWidgetArticlesQueueName"
  }
],
v33 = [
  {
    "kind": "Variable",
    "name": "spotlightQueueName",
    "variableName": "spotlightQueueName"
  }
],
v34 = [
  {
    "kind": "Variable",
    "name": "focusQueueName",
    "variableName": "focusQueueName"
  }
],
v35 = [
  {
    "kind": "Variable",
    "name": "edition",
    "variableName": "liveWidgetEditionEnumValue"
  }
],
v36 = {
  "kind": "Variable",
  "name": "applicationId",
  "variableName": "applicationId"
},
v37 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "commentQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v38 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v39 = [
  (v38/*: any*/)
],
v40 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v25/*: any*/)
    ],
    "storageKey": null
  }
],
v41 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "storyPackageArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v42 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v43 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "spotlightQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v45 = [
  {
    "alias": null,
    "args": (v44/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v40/*: any*/),
    "storageKey": "items(first:4)"
  }
],
v46 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "secondaryStoryPackageArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v54 = [
  (v53/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v51/*: any*/),
    (v52/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v54/*: any*/),
      "storageKey": null
    },
    (v55/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v58 = [
  (v57/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v51/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v59/*: any*/),
    (v60/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v58/*: any*/),
      "storageKey": null
    },
    (v55/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v55/*: any*/)
  ],
  "storageKey": null
},
v65 = [
  (v48/*: any*/),
  (v55/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v65/*: any*/),
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "Section",
  "kind": "LinkedField",
  "name": "fullSectionPath",
  "plural": true,
  "selections": (v65/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v67/*: any*/),
    (v68/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v55/*: any*/)
  ],
  "storageKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    (v70/*: any*/),
    (v71/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v73 = [
  (v48/*: any*/)
],
v74 = {
  "kind": "InlineFragment",
  "selections": (v73/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v55/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v76 = {
  "kind": "InlineFragment",
  "selections": (v73/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v63/*: any*/),
    (v55/*: any*/)
  ],
  "storageKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v47/*: any*/),
            (v74/*: any*/),
            (v75/*: any*/),
            (v76/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v78/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v72/*: any*/),
    (v79/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v56/*: any*/),
    (v55/*: any*/),
    (v61/*: any*/),
    (v49/*: any*/),
    (v51/*: any*/),
    (v62/*: any*/),
    (v80/*: any*/)
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v88 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "1200x800"
    }
  }
],
v89 = {
  "alias": "size1200x800",
  "args": (v88/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v90 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v91 = [
  (v53/*: any*/),
  (v87/*: any*/),
  (v52/*: any*/),
  (v89/*: any*/),
  (v90/*: any*/)
],
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v91/*: any*/),
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v94 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isSectionUnion"
},
v95 = {
  "kind": "InlineFragment",
  "selections": [
    (v51/*: any*/),
    (v61/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v96 = [
  (v51/*: any*/)
],
v97 = {
  "kind": "InlineFragment",
  "selections": (v96/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v98 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v63/*: any*/),
    (v49/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v72/*: any*/),
    (v79/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v47/*: any*/),
        (v94/*: any*/),
        (v95/*: any*/),
        (v97/*: any*/),
        (v75/*: any*/),
        (v98/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v101 = [
  (v100/*: any*/)
],
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v101/*: any*/),
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v100/*: any*/),
    (v57/*: any*/)
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v74/*: any*/),
        (v76/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    (v105/*: any*/),
    (v78/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v72/*: any*/),
    (v106/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/),
    (v48/*: any*/),
    (v63/*: any*/),
    (v49/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v72/*: any*/),
    (v79/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v110 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v108/*: any*/),
    (v55/*: any*/),
    (v109/*: any*/)
  ],
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v101/*: any*/),
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v48/*: any*/),
        (v55/*: any*/),
        (v51/*: any*/),
        (v59/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "leadingSlides",
  "plural": true,
  "selections": (v91/*: any*/),
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v117/*: any*/),
    (v55/*: any*/),
    (v48/*: any*/)
  ],
  "storageKey": null
},
v119 = {
  "kind": "InlineFragment",
  "selections": [
    (v105/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v120 = {
  "kind": "InlineFragment",
  "selections": [
    (v70/*: any*/),
    (v71/*: any*/),
    (v108/*: any*/),
    (v110/*: any*/),
    (v77/*: any*/),
    (v111/*: any*/),
    (v112/*: any*/),
    (v113/*: any*/),
    (v114/*: any*/),
    (v115/*: any*/),
    (v116/*: any*/),
    (v118/*: any*/),
    (v61/*: any*/),
    (v119/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v76/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v124 = {
  "kind": "InlineFragment",
  "selections": [
    (v121/*: any*/),
    (v122/*: any*/),
    (v123/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v125 = {
  "kind": "InlineFragment",
  "selections": (v96/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v47/*: any*/),
        (v125/*: any*/),
        (v97/*: any*/),
        (v75/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v56/*: any*/),
    (v55/*: any*/)
  ],
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v51/*: any*/),
        (v48/*: any*/),
        (v59/*: any*/),
        (v55/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v129 = {
  "kind": "InlineFragment",
  "selections": [
    (v128/*: any*/),
    (v118/*: any*/),
    (v111/*: any*/),
    (v119/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v131 = [
  (v51/*: any*/),
  (v130/*: any*/)
],
v132 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/),
    (v48/*: any*/),
    (v125/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v131/*: any*/),
      "type": "Author",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v131/*: any*/),
      "type": "Topic",
      "abstractKey": null
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v133 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/),
    (v108/*: any*/),
    (v110/*: any*/),
    (v111/*: any*/),
    (v112/*: any*/),
    (v113/*: any*/),
    (v114/*: any*/),
    (v115/*: any*/),
    (v118/*: any*/),
    (v61/*: any*/),
    (v119/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v56/*: any*/),
    (v55/*: any*/),
    (v49/*: any*/),
    (v51/*: any*/),
    (v62/*: any*/),
    (v61/*: any*/),
    (v80/*: any*/)
  ],
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v100/*: any*/)
  ],
  "storageKey": null
},
v136 = {
  "kind": "InlineFragment",
  "selections": [
    (v122/*: any*/),
    (v123/*: any*/),
    (v121/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v137 = {
  "kind": "Variable",
  "name": "paywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v138 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "articleTypeIds",
      "variableName": "latestExcludeArticleTypes"
    },
    (v137/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "articleExcludeInput"
},
v139 = {
  "kind": "Literal",
  "name": "articleFilterInput",
  "value": {
    "sponsorTypes": [
      "NONE"
    ]
  }
},
v140 = {
  "kind": "Literal",
  "name": "contentTypes",
  "value": [
    "ARTICLE",
    "GALLERY",
    "VIDEO"
  ]
},
v141 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "sectionIds",
      "variableName": "latestExcludeSectionIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "exclude"
},
v142 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v143 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v144 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
},
v145 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v47/*: any*/),
        (v94/*: any*/),
        (v125/*: any*/),
        (v97/*: any*/),
        (v75/*: any*/),
        (v98/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v146 = {
  "kind": "InlineFragment",
  "selections": [
    (v112/*: any*/),
    (v113/*: any*/),
    (v114/*: any*/),
    (v115/*: any*/),
    (v118/*: any*/),
    (v111/*: any*/),
    (v119/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v147 = {
  "kind": "InlineFragment",
  "selections": [
    (v122/*: any*/),
    (v123/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v148 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "homepage_service_journalism_hk"
    }
  }
],
v149 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settings",
  "storageKey": null
},
v150 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v63/*: any*/),
    (v51/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "AUTHOR_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "300x300"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v54/*: any*/),
          "storageKey": "style(filter:{\"style\":\"300x300\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
    },
    (v55/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        (v49/*: any*/),
        (v64/*: any*/),
        (v66/*: any*/),
        (v69/*: any*/),
        (v72/*: any*/),
        (v79/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v151 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v117/*: any*/)
  ],
  "storageKey": null
},
v152 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v153 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v72/*: any*/),
    (v79/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v154 = [
  (v142/*: any*/)
],
v155 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "chinaFutureTechSectionEntityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v156 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "TERM_LOGO"
    }
  }
],
v157 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "style": "100x100"
        }
      }
    ],
    "concreteType": "ImageStyle",
    "kind": "LinkedField",
    "name": "style",
    "plural": false,
    "selections": (v54/*: any*/),
    "storageKey": "style(filter:{\"style\":\"100x100\"})"
  }
],
v158 = {
  "alias": "sectionLogo",
  "args": (v156/*: any*/),
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v157/*: any*/),
  "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
},
v159 = {
  "alias": null,
  "args": null,
  "concreteType": "Queue",
  "kind": "LinkedField",
  "name": "subSections",
  "plural": false,
  "selections": [
    (v149/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v47/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v51/*: any*/),
                    (v49/*: any*/)
                  ],
                  "type": "Topic",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v51/*: any*/),
                    (v49/*: any*/),
                    (v64/*: any*/)
                  ],
                  "type": "Section",
                  "abstractKey": null
                },
                (v98/*: any*/),
                (v75/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v55/*: any*/)
  ],
  "storageKey": null
},
v160 = [
  (v130/*: any*/)
],
v161 = {
  "kind": "InlineFragment",
  "selections": (v160/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v162 = {
  "kind": "InlineFragment",
  "selections": (v160/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v163 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v63/*: any*/),
    (v49/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v72/*: any*/),
    (v79/*: any*/),
    (v161/*: any*/),
    (v162/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v164 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "chinaFutureTechStoryPackageArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v165 = {
  "alias": null,
  "args": (v44/*: any*/),
  "concreteType": "QueueItemConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v47/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v48/*: any*/),
                (v49/*: any*/),
                (v134/*: any*/),
                (v82/*: any*/),
                (v83/*: any*/),
                (v84/*: any*/),
                (v85/*: any*/),
                (v86/*: any*/),
                (v92/*: any*/),
                (v93/*: any*/),
                (v50/*: any*/),
                (v99/*: any*/),
                (v135/*: any*/),
                (v102/*: any*/),
                (v104/*: any*/),
                (v107/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v77/*: any*/),
                    (v70/*: any*/),
                    (v71/*: any*/),
                    (v108/*: any*/),
                    (v110/*: any*/),
                    (v111/*: any*/),
                    (v112/*: any*/),
                    (v113/*: any*/),
                    (v114/*: any*/),
                    (v115/*: any*/),
                    (v116/*: any*/),
                    (v118/*: any*/),
                    (v61/*: any*/),
                    (v119/*: any*/)
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                (v136/*: any*/)
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            },
            (v75/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "items(first:4)"
},
v166 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "refTerms",
  "plural": true,
  "selections": [
    (v47/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latestArticleLink",
          "storageKey": null
        }
      ],
      "type": "Newsletter",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/),
        (v158/*: any*/),
        (v163/*: any*/)
      ],
      "type": "Section",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "TERM_LOGO"
            }
          ],
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v157/*: any*/),
          "storageKey": "image(type:\"TERM_LOGO\")"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v48/*: any*/),
            (v63/*: any*/),
            (v49/*: any*/),
            (v64/*: any*/),
            (v66/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v67/*: any*/),
                (v68/*: any*/),
                (v48/*: any*/)
              ],
              "type": "Section",
              "abstractKey": null
            },
            (v72/*: any*/),
            (v79/*: any*/),
            (v161/*: any*/),
            (v162/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "type": "Topic",
      "abstractKey": null
    },
    (v75/*: any*/)
  ],
  "storageKey": null
},
v167 = {
  "alias": "landscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v168 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "seriesWidgetArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v169 = [
  (v51/*: any*/),
  (v98/*: any*/)
],
v170 = {
  "alias": null,
  "args": (v44/*: any*/),
  "concreteType": "QueueItemConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v47/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v48/*: any*/),
                (v49/*: any*/),
                (v86/*: any*/),
                (v92/*: any*/),
                (v50/*: any*/),
                (v81/*: any*/),
                (v82/*: any*/),
                (v83/*: any*/),
                (v84/*: any*/),
                (v85/*: any*/),
                (v93/*: any*/),
                (v99/*: any*/),
                (v102/*: any*/),
                (v103/*: any*/),
                (v104/*: any*/),
                (v107/*: any*/),
                (v120/*: any*/),
                (v124/*: any*/)
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            },
            (v75/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "items(first:4)"
},
v171 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "focusQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v172 = [
  (v152/*: any*/)
],
v173 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v65/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v174 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v47/*: any*/),
            (v76/*: any*/),
            (v75/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
},
v175 = [
  (v51/*: any*/),
  (v48/*: any*/)
],
v176 = {
  "kind": "Literal",
  "name": "first",
  "value": 2
},
v177 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v53/*: any*/),
    (v87/*: any*/),
    (v52/*: any*/),
    (v90/*: any*/)
  ],
  "storageKey": null
},
v178 = {
  "typeIds": [
    "09ecd76b-0271-467d-be05-c228b9a8ef47"
  ]
},
v179 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v48/*: any*/),
          (v55/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v49/*: any*/),
              (v86/*: any*/),
              (v177/*: any*/),
              (v93/*: any*/),
              (v47/*: any*/),
              (v50/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v84/*: any*/),
              (v107/*: any*/),
              (v129/*: any*/)
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homePageQuery",
    "selections": [
      {
        "alias": "topStories",
        "args": (v22/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "heroArticleThreeArticleIds"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "heroSecondaryArticlesHomeV2QueueItemsEdge"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "heroThreeArticlesQueueItemsEdge"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "topStoriesHomeV2QueueItemsEdge"
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "heroArticleArticle"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "heroArticlesHomeV2Content"
                      }
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:18)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "morningStudioQueue",
        "args": (v26/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksPickMorningStudioArticle",
            "selections": [
              {
                "alias": null,
                "args": (v27/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "aiArticleListSponsoredArticle"
                          }
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:9)"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksHomeV2PickMorningStudioArticle",
            "selections": [
              {
                "alias": null,
                "args": (v27/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "homeNativeArticleContentItemContent"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "v2RecommendedForYouSponsorArticleQueueItemsEdge"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:9)"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      },
      {
        "args": (v29/*: any*/),
        "kind": "FragmentSpread",
        "name": "latestContentsQuery"
      },
      {
        "args": (v29/*: any*/),
        "kind": "FragmentSpread",
        "name": "latestContentsHomeV2Query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "thingsToDoQueue"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "thingsToDoHomeV2Query"
      },
      {
        "args": (v30/*: any*/),
        "kind": "FragmentSpread",
        "name": "commentQueueQuery"
      },
      {
        "args": (v30/*: any*/),
        "kind": "FragmentSpread",
        "name": "opinionHomeV2QueueQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "queueName",
            "variableName": "chinaFutureTechStoryPackageArticlesQueueName"
          },
          {
            "kind": "Variable",
            "name": "sectionEntityId",
            "variableName": "chinaFutureTechSectionEntityId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "chinaFutureTechStoryPackageQuery"
      },
      {
        "args": (v31/*: any*/),
        "kind": "FragmentSpread",
        "name": "secondaryStoryPackageQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "storyPackageArticlesQueueName",
            "variableName": "storyPackageArticlesQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "storyPackageQuery"
      },
      {
        "args": (v32/*: any*/),
        "kind": "FragmentSpread",
        "name": "seriesWidgetQuery"
      },
      {
        "args": (v33/*: any*/),
        "kind": "FragmentSpread",
        "name": "spotlightQuery"
      },
      {
        "args": (v32/*: any*/),
        "kind": "FragmentSpread",
        "name": "seriesWidgetHomeV2Query"
      },
      {
        "args": (v31/*: any*/),
        "kind": "FragmentSpread",
        "name": "secondaryStoryPackageHomeV2Query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "chinaFutureTechSectionEntityId",
            "variableName": "chinaFutureTechSectionEntityId"
          },
          {
            "kind": "Variable",
            "name": "chinaFutureTechStoryPackageArticlesQueueName",
            "variableName": "chinaFutureTechStoryPackageArticlesQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "chinaFutureTechStoryPackageHomeV2Query"
      },
      {
        "args": (v33/*: any*/),
        "kind": "FragmentSpread",
        "name": "spotlightHomeV2Query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "scmpShortsQueueName",
            "variableName": "scmpShortsQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "scmpShortsHomeV2Query"
      },
      {
        "args": (v34/*: any*/),
        "kind": "FragmentSpread",
        "name": "focusArticleHomeFocusArticleQuery"
      },
      {
        "args": (v34/*: any*/),
        "kind": "FragmentSpread",
        "name": "flexiUnitHomeV2QueueQuery"
      },
      {
        "args": (v35/*: any*/),
        "kind": "FragmentSpread",
        "name": "superSplashQuery"
      },
      {
        "args": (v35/*: any*/),
        "kind": "FragmentSpread",
        "name": "superSplashHomeV2Query"
      },
      {
        "args": [
          (v36/*: any*/),
          {
            "kind": "Variable",
            "name": "dailyPulseTypeUuId",
            "variableName": "dailyPulseTypeUuId"
          },
          {
            "kind": "Variable",
            "name": "highlightQueueName",
            "variableName": "highlightQueueName"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaEndDate",
            "variableName": "plusNewsAgendaEndDate"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaStartDate",
            "variableName": "plusNewsAgendaStartDate"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaTypes",
            "variableName": "plusNewsAgendaTypes"
          }
        ],
        "kind": "FragmentSpread",
        "name": "plusWidgetQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "chinaScienceDiscoveryWidgetQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "hooksPlusWidgetConfigQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "plusWidgetHomeV2Query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "hooksPremiumNativeAdConfigQuery"
      },
      {
        "alias": "commentQueue",
        "args": (v37/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v39/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": "items(first:5)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "storyPackageArticles",
        "args": (v41/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v42/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": "items(first:3)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "spotlightQueue",
        "args": (v43/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v45/*: any*/),
        "storageKey": null
      },
      {
        "alias": "secondaryStoryPackageArticles",
        "args": (v46/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v45/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Operation",
    "name": "homePageQuery",
    "selections": [
      {
        "alias": "topStories",
        "args": (v22/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v99/*: any*/),
                          (v102/*: any*/),
                          (v103/*: any*/),
                          (v104/*: any*/),
                          (v107/*: any*/),
                          (v120/*: any*/),
                          (v124/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Article",
                            "kind": "LinkedField",
                            "name": "moreOnThisArticles",
                            "plural": true,
                            "selections": [
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v55/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v86/*: any*/),
                                  (v93/*: any*/),
                                  (v47/*: any*/),
                                  (v50/*: any*/),
                                  (v126/*: any*/),
                                  (v127/*: any*/),
                                  (v129/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v47/*: any*/),
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v66/*: any*/),
                                  (v69/*: any*/),
                                  (v72/*: any*/),
                                  (v106/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v55/*: any*/),
                              (v132/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v66/*: any*/),
                              (v69/*: any*/),
                              (v72/*: any*/),
                              (v119/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:18)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "morningStudioQueue",
        "args": (v26/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v27/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/),
                              (v50/*: any*/),
                              (v99/*: any*/),
                              (v102/*: any*/),
                              (v103/*: any*/),
                              (v104/*: any*/),
                              (v107/*: any*/),
                              (v133/*: any*/),
                              (v124/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v75/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v134/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v99/*: any*/),
                          (v135/*: any*/),
                          (v102/*: any*/),
                          (v104/*: any*/),
                          (v107/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v77/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v108/*: any*/),
                              (v110/*: any*/),
                              (v111/*: any*/),
                              (v112/*: any*/),
                              (v113/*: any*/),
                              (v114/*: any*/),
                              (v115/*: any*/),
                              (v116/*: any*/),
                              (v118/*: any*/),
                              (v61/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v66/*: any*/),
                                  (v69/*: any*/),
                                  (v119/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              },
                              (v119/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v136/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:9)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v138/*: any*/),
          (v139/*: any*/),
          (v140/*: any*/),
          (v141/*: any*/),
          (v142/*: any*/),
          (v143/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v144/*: any*/),
                  (v49/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v92/*: any*/),
                  (v93/*: any*/),
                  (v50/*: any*/),
                  (v145/*: any*/),
                  (v127/*: any*/),
                  (v55/*: any*/),
                  (v107/*: any*/),
                  (v146/*: any*/),
                  (v147/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "latestV2Contents",
        "args": [
          (v138/*: any*/),
          (v139/*: any*/),
          (v140/*: any*/),
          (v141/*: any*/),
          (v38/*: any*/),
          (v143/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v144/*: any*/),
                  (v49/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v93/*: any*/),
                  (v50/*: any*/),
                  (v145/*: any*/),
                  (v127/*: any*/),
                  (v55/*: any*/),
                  (v107/*: any*/),
                  (v146/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "thingToDoQueue",
        "args": (v148/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v149/*: any*/),
          {
            "alias": null,
            "args": (v42/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v99/*: any*/),
                          (v102/*: any*/),
                          (v103/*: any*/),
                          (v104/*: any*/),
                          (v107/*: any*/),
                          (v133/*: any*/),
                          (v124/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:3)"
          },
          (v55/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_service_journalism_hk\"})"
      },
      {
        "alias": "thingToDoV2Queue",
        "args": (v148/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v149/*: any*/),
          {
            "alias": null,
            "args": (v42/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v53/*: any*/),
                              (v87/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": "size500x500",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "500x500"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v54/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"500x500\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v145/*: any*/),
                          (v127/*: any*/),
                          (v107/*: any*/),
                          (v146/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:3)"
          },
          (v55/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_service_journalism_hk\"})"
      },
      {
        "alias": "commentSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "93"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v49/*: any*/),
          (v55/*: any*/),
          (v132/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"93\"})"
      },
      {
        "alias": "commentQueue",
        "args": (v37/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v39/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v150/*: any*/),
                          (v50/*: any*/),
                          (v86/*: any*/),
                          (v93/*: any*/),
                          (v126/*: any*/),
                          (v127/*: any*/),
                          (v107/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v112/*: any*/),
                              (v113/*: any*/),
                              (v114/*: any*/),
                              (v115/*: any*/),
                              (v151/*: any*/),
                              (v111/*: any*/),
                              (v119/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v122/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "type": "MAIN_IMAGE"
                                    }
                                  }
                                ],
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "alt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v88/*: any*/),
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v54/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                  }
                                ],
                                "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                              }
                            ],
                            "type": "Video",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "harryContents",
        "args": [
          {
            "fields": [
              (v137/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "articleExcludeInput"
          },
          {
            "kind": "Literal",
            "name": "contentTypes",
            "value": [
              "GALLERY"
            ]
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "sectionIds",
                "variableName": "commentHarrySectionIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v152/*: any*/),
          (v143/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v144/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v86/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v53/*: any*/),
                      (v87/*: any*/),
                      (v52/*: any*/),
                      {
                        "alias": "size660w",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "660w"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v54/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"660w\"})"
                      }
                    ],
                    "storageKey": null
                  },
                  (v127/*: any*/),
                  (v55/*: any*/),
                  (v153/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v111/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "opinionQueue",
        "args": (v37/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v154/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v150/*: any*/),
                          (v50/*: any*/),
                          (v86/*: any*/),
                          (v93/*: any*/),
                          (v126/*: any*/),
                          (v127/*: any*/),
                          (v84/*: any*/),
                          (v107/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v114/*: any*/),
                              (v151/*: any*/),
                              (v111/*: any*/),
                              (v108/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Article",
                                "kind": "LinkedField",
                                "name": "seriesContainer",
                                "plural": false,
                                "selections": [
                                  (v108/*: any*/),
                                  (v55/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v119/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v155/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v51/*: any*/),
          (v158/*: any*/),
          (v159/*: any*/),
          (v47/*: any*/),
          (v55/*: any*/),
          (v163/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "chinaFutureTechStoryPackageArticles",
        "args": (v164/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v149/*: any*/),
          (v165/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "secondaryStoryPackageArticles",
        "args": (v46/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v166/*: any*/),
          (v149/*: any*/),
          (v165/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "storyPackageArticles",
        "args": (v41/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v166/*: any*/),
          (v149/*: any*/),
          {
            "alias": null,
            "args": (v42/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v53/*: any*/),
                              (v87/*: any*/),
                              (v52/*: any*/),
                              (v167/*: any*/),
                              (v90/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v126/*: any*/),
                          (v127/*: any*/),
                          (v60/*: any*/),
                          (v107/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v112/*: any*/),
                              (v113/*: any*/),
                              (v114/*: any*/),
                              (v115/*: any*/),
                              (v118/*: any*/),
                              (v111/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v119/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v147/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:3)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "seriesWidgetArticles",
        "args": (v168/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v108/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "series",
                            "plural": true,
                            "selections": [
                              (v47/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v48/*: any*/),
                                  (v84/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v53/*: any*/),
                                      (v87/*: any*/),
                                      (v52/*: any*/),
                                      (v167/*: any*/),
                                      (v90/*: any*/),
                                      (v89/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v81/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v85/*: any*/),
                                  (v93/*: any*/),
                                  (v50/*: any*/),
                                  (v99/*: any*/),
                                  (v102/*: any*/),
                                  (v103/*: any*/),
                                  (v104/*: any*/),
                                  (v107/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v77/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      (v111/*: any*/),
                                      (v112/*: any*/),
                                      (v113/*: any*/),
                                      (v114/*: any*/),
                                      (v115/*: any*/),
                                      (v118/*: any*/),
                                      (v61/*: any*/),
                                      (v108/*: any*/),
                                      (v110/*: any*/),
                                      (v119/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  (v124/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          (v153/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "spotlightQueue",
        "args": (v43/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v165/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "seriesWidgetV2Articles",
        "args": (v168/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v108/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "series",
                            "plural": true,
                            "selections": [
                              (v47/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v48/*: any*/),
                                  (v84/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v81/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v53/*: any*/),
                                      (v87/*: any*/),
                                      (v52/*: any*/),
                                      (v89/*: any*/),
                                      (v90/*: any*/),
                                      (v167/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v93/*: any*/),
                                  (v99/*: any*/),
                                  (v102/*: any*/),
                                  (v103/*: any*/),
                                  (v104/*: any*/),
                                  (v107/*: any*/),
                                  (v120/*: any*/),
                                  (v124/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          (v153/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "secondaryStoryPackageV2Articles",
        "args": (v46/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "refTerms",
            "plural": true,
            "selections": [
              (v47/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v96/*: any*/),
                "type": "Newsletter",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v169/*: any*/),
                "type": "Section",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v169/*: any*/),
                "type": "Topic",
                "abstractKey": null
              },
              (v75/*: any*/)
            ],
            "storageKey": null
          },
          (v149/*: any*/),
          (v170/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "chinaFutureTechV2Section",
        "args": (v155/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v51/*: any*/),
          (v159/*: any*/),
          (v55/*: any*/),
          (v109/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "chinaFutureTechStoryPackageV2Articles",
        "args": (v164/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v149/*: any*/),
          (v170/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "spotlightV2Queue",
        "args": (v43/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v170/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "scmpShortsV2Queue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "scmpShortsQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v39/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v86/*: any*/),
                          (v49/*: any*/),
                          (v121/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "portraitStyle",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "portrait"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v54/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"portrait\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v153/*: any*/)
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "focus",
        "args": (v171/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v149/*: any*/),
          {
            "alias": null,
            "args": (v172/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v86/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v53/*: any*/),
                              (v87/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": "size1280x720",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v54/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                              },
                              {
                                "alias": "size640x360",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape_640_360"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v54/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v126/*: any*/),
                          (v127/*: any*/),
                          (v49/*: any*/),
                          (v107/*: any*/),
                          (v147/*: any*/),
                          (v129/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v173/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v47/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v51/*: any*/),
                                      (v49/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v156/*: any*/),
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": (v157/*: any*/),
                                        "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
                                      }
                                    ],
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  (v75/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v70/*: any*/),
                          (v71/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v174/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:1)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "homeV2FlexiUnit",
        "args": (v171/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v149/*: any*/),
          {
            "alias": null,
            "args": (v172/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v86/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v126/*: any*/),
                          (v127/*: any*/),
                          (v60/*: any*/),
                          (v107/*: any*/),
                          (v129/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v173/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v174/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:1)"
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": (v35/*: any*/),
            "kind": "ObjectValue",
            "name": "filter"
          },
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "DESC",
              "field": "UPDATED_DATE"
            }
          }
        ],
        "concreteType": "LiveWidget",
        "kind": "LinkedField",
        "name": "liveWidget",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "style",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "relatedArticles",
            "plural": true,
            "selections": [
              (v63/*: any*/),
              (v49/*: any*/),
              (v55/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v48/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v47/*: any*/),
                  (v86/*: any*/),
                  (v92/*: any*/),
                  (v93/*: any*/),
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v47/*: any*/),
                          (v95/*: any*/),
                          (v97/*: any*/),
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v48/*: any*/),
                      (v56/*: any*/),
                      (v55/*: any*/),
                      (v61/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v102/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": (v101/*: any*/),
                    "storageKey": null
                  },
                  (v104/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v69/*: any*/),
                      (v72/*: any*/),
                      (v106/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v112/*: any*/),
                      (v113/*: any*/),
                      (v114/*: any*/),
                      (v115/*: any*/),
                      (v116/*: any*/),
                      (v118/*: any*/),
                      (v111/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v61/*: any*/),
                      (v119/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v121/*: any*/)
                    ],
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "dailyPulseQuery",
        "args": [
          {
            "fields": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "typeIds.0",
                    "variableName": "dailyPulseTypeUuId"
                  }
                ],
                "kind": "ListValue",
                "name": "typeIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v152/*: any*/),
          (v143/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v55/*: any*/),
                  (v80/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v86/*: any*/),
                      (v93/*: any*/),
                      (v47/*: any*/),
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v47/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v175/*: any*/),
                                "type": "Section",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v175/*: any*/),
                                "type": "VideoSection",
                                "abstractKey": null
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v127/*: any*/),
                      (v82/*: any*/),
                      (v84/*: any*/),
                      (v83/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v128/*: any*/),
                          (v118/*: any*/),
                          (v111/*: any*/),
                          (v77/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "highlightQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "highlightQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v176/*: any*/)
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v86/*: any*/),
                          (v177/*: any*/),
                          (v93/*: any*/),
                          (v50/*: any*/),
                          (v145/*: any*/),
                          (v127/*: any*/),
                          (v107/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v77/*: any*/),
                              (v114/*: any*/),
                              (v118/*: any*/),
                              (v111/*: any*/),
                              (v119/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:2)"
          },
          (v55/*: any*/),
          (v149/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v36/*: any*/),
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "endDate",
                    "variableName": "plusNewsAgendaEndDate"
                  },
                  {
                    "kind": "Variable",
                    "name": "startDate",
                    "variableName": "plusNewsAgendaStartDate"
                  }
                ],
                "kind": "ObjectValue",
                "name": "newsAgendaDateRange"
              },
              {
                "kind": "Literal",
                "name": "newsAgendaOptions",
                "value": [
                  "key_event"
                ]
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "plusNewsAgendaTypes"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v38/*: any*/),
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "ASC",
              "field": "NEWS_AGENDA_START_DATE"
            }
          }
        ],
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewsAgenda",
                    "kind": "LinkedField",
                    "name": "newsAgenda",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "secondaryDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "time",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newsAgendaOptions",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v48/*: any*/),
                  (v51/*: any*/),
                  (v59/*: any*/),
                  (v83/*: any*/),
                  (v55/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_settings"
            }
          }
        ],
        "concreteType": "AppConfigs",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v101/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
      },
      {
        "alias": "chinaScienceSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "328475"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v49/*: any*/),
          (v51/*: any*/),
          (v48/*: any*/),
          (v68/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"328475\"})"
      },
      {
        "alias": "chinaScienceQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "section_top_328475"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v154/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v49/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/),
                              (v50/*: any*/),
                              (v99/*: any*/),
                              (v102/*: any*/),
                              (v103/*: any*/),
                              (v104/*: any*/),
                              (v107/*: any*/),
                              (v133/*: any*/),
                              (v124/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v55/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
      },
      {
        "alias": "dailyPulseArticles",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": (v178/*: any*/)
          },
          (v152/*: any*/),
          (v143/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v179/*: any*/),
        "storageKey": "articles(filter:{\"typeIds\":[\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]},first:1,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
      },
      {
        "alias": "plusArticles",
        "args": [
          {
            "kind": "Literal",
            "name": "exclude",
            "value": (v178/*: any*/)
          },
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "paywallTypeIds": [
                "716f570e-3083-4138-a080-47d3830fafe3"
              ]
            }
          },
          (v176/*: any*/),
          (v143/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v179/*: any*/),
        "storageKey": "articles(exclude:{\"typeIds\":[\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]},filter:{\"paywallTypeIds\":[\"716f570e-3083-4138-a080-47d3830fafe3\"]},first:2,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
      },
      {
        "alias": "advertConfig",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_advert_campaign"
            }
          }
        ],
        "concreteType": "AppConfigs",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v101/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
      }
    ]
  },
  "params": {
    "cacheID": "9c7a23f9913c1c2b09c5383b06748241",
    "id": null,
    "metadata": {},
    "name": "homePageQuery",
    "operationKind": "query",
    "text": "query homePageQuery(\n  $applicationId: String!\n  $chinaFutureTechSectionEntityId: String!\n  $chinaFutureTechStoryPackageArticlesQueueName: String!\n  $commentHarrySectionIds: [String]\n  $commentQueueName: String!\n  $dailyPulseTypeUuId: String!\n  $focusQueueName: String!\n  $highlightQueueName: String!\n  $latestExcludeArticleTypes: [String]\n  $latestExcludeSectionIds: [String]\n  $liveWidgetEditionEnumValue: LiveWidgetEditionEnum!\n  $morningStudioQueueName: String!\n  $plusNewsAgendaEndDate: Timestamp!\n  $plusNewsAgendaStartDate: Timestamp!\n  $plusNewsAgendaTypes: [String]!\n  $scmpPlusPaywallTypeIds: [String]\n  $scmpShortsQueueName: String!\n  $spotlightQueueName: String!\n  $storyPackageArticlesQueueName: String!\n  $secondaryStoryPackageArticlesQueueName: String!\n  $seriesWidgetArticlesQueueName: String!\n  $topStoriesQueueName: String!\n) {\n  topStories: queue(filter: {name: $topStoriesQueueName}) {\n    items(first: 18) {\n      edges {\n        ...heroArticleThreeArticleIds\n        ...heroSecondaryArticlesHomeV2QueueItemsEdge\n        ...heroThreeArticlesQueueItemsEdge\n        ...topStoriesHomeV2QueueItemsEdge\n        ...topStoriesQueueItemsEdge\n        node {\n          __typename\n          ...heroArticleArticle\n          ...heroArticlesHomeV2Content\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  morningStudioQueue: queue(filter: {name: $morningStudioQueueName}) {\n    ...hooksPickMorningStudioArticle\n    ...hooksHomeV2PickMorningStudioArticle\n    id\n  }\n  ...latestContentsQuery_2HMWA1\n  ...latestContentsHomeV2Query_2HMWA1\n  ...thingsToDoQueue\n  ...thingsToDoHomeV2Query\n  ...commentQueueQuery_pwKp9\n  ...opinionHomeV2QueueQuery_pwKp9\n  ...chinaFutureTechStoryPackageQuery_4sW4gC\n  ...secondaryStoryPackageQuery_1swAuP\n  ...storyPackageQuery_1ZDJci\n  ...seriesWidgetQuery_iI4uX\n  ...spotlightQuery_Mf8QP\n  ...seriesWidgetHomeV2Query_iI4uX\n  ...secondaryStoryPackageHomeV2Query_1swAuP\n  ...chinaFutureTechStoryPackageHomeV2Query_2L4VJY\n  ...spotlightHomeV2Query_Mf8QP\n  ...scmpShortsHomeV2Query_3hK5ms\n  ...focusArticleHomeFocusArticleQuery_4COOKT\n  ...flexiUnitHomeV2QueueQuery_4COOKT\n  ...superSplashQuery_3oF9in\n  ...superSplashHomeV2Query_3oF9in\n  ...plusWidgetQuery_1YyBVf\n  ...chinaScienceDiscoveryWidgetQuery\n  ...hooksPlusWidgetConfigQuery\n  ...plusWidgetHomeV2Query\n  ...hooksPremiumNativeAdConfigQuery\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 5) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  storyPackageArticles: queue(filter: {name: $storyPackageArticlesQueueName}) {\n    items(first: 3) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  spotlightQueue: queue(filter: {name: $spotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  secondaryStoryPackageArticles: queue(filter: {name: $secondaryStoryPackageArticlesQueueName}) {\n    items(first: 4) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment aiArticleListSponsoredArticle on Article {\n  entityId\n  urlAlias\n  ...homeSecondaryContentItemContent\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaFutureTechStoryPackageHomeV2Query_2L4VJY on Query {\n  chinaFutureTechV2Section: section(filter: {entityId: $chinaFutureTechSectionEntityId}) {\n    name\n    subSections {\n      settings\n      items {\n        edges {\n          ...entityOnelineMenuQueueItemsEdge\n        }\n      }\n      id\n    }\n    ...entityLink\n    id\n  }\n  chinaFutureTechStoryPackageV2Articles: queue(filter: {name: $chinaFutureTechStoryPackageArticlesQueueName}) {\n    settings\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...sectionStoryBlockHomeV2QueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment chinaFutureTechStoryPackageQuery_4sW4gC on Query {\n  section(filter: {entityId: $chinaFutureTechSectionEntityId}) {\n    name\n    ...entityLink\n    ...followButtonBase\n    ...sectionTermLogoSection\n    subSections {\n      settings\n      items {\n        edges {\n          ...entityOnelineMenuQueueItemsEdge\n        }\n      }\n      id\n    }\n    __typename\n    id\n  }\n  chinaFutureTechStoryPackageArticles: queue(filter: {name: $chinaFutureTechStoryPackageArticlesQueueName}) {\n    settings\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...topStoriesBlockQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment chinaScienceDiscoveryWidgetQuery on Query {\n  chinaScienceSection: section(filter: {entityId: \"328475\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment commentContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2RX0zR\n  ... on Video {\n    headline\n    duration\n    image(filter: {type: MAIN_IMAGE}) {\n      alt\n      style(filter: {style: \"1200x800\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment commentQueueQuery_pwKp9 on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    ...followButtonBase\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  harryContents: contents(contentTypes: [GALLERY], first: 1, filter: {sectionIds: $commentHarrySectionIds}, articleExcludeInput: {paywallTypeIds: $scmpPlusPaywallTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        entityId\n        ...harryContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment commentV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_13FlZp\n  ... on Article {\n    authors {\n      entityId\n      id\n    }\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAgendaContentTopic on Topic {\n  newsAgenda {\n    secondaryDescription\n  }\n  description {\n    text\n  }\n  updatedDate\n  name\n  ...hooksNewsAgendaTopic\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_1mXwiv on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size660w: style(filter: {style: \"660w\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1pemU3 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1tYcF5 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_2Ihffa on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4Kx38 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_ScPJx on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_wy32c on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentPublishedDateContent on Content {\n  __isContent: __typename\n  publishedDate\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityOnelineMenuQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment flexiUnitHomeV2QueueQuery_4COOKT on Query {\n  homeV2FlexiUnit: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ...helpersGetFlexiUnitArticleLabelArticle\n          ...helpersGetFlexiUnitPodcastLabelPodcast\n          ...helpersGetFlexiUnitVideoLabelVideo\n          ...homeV2FlexiUnitContentItemContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment focusArticleHomeFocusArticleQuery_4COOKT on Query {\n  focus: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ...homeFocusContentItemContent\n          ...helpersGetArticleTitleArticle\n          ...helpersGetPodcastTitlePodcast\n          ...helpersGetVideoTitleVideo\n          ...helpersCheckIsLiveArticle\n          ...helpersGetArticleLogoArticle\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment harryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3V3HsH\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleLogoArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n        urlAlias\n        image(filter: {type: TERM_LOGO}) {\n          style(filter: {style: \"100x100\"}) {\n            url\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTitleArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetFlexiUnitArticleLabelArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetFlexiUnitPodcastLabelPodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetFlexiUnitVideoLabelVideo on Video {\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetPodcastTitlePodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetVideoTitleVideo on Video {\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment heroArticleArticle on Article {\n  ...homeHeroArticleContentItemContent\n  entityId\n  moreOnThisArticles {\n    entityId\n    id\n  }\n}\n\nfragment heroArticleThreeArticleIds on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment heroArticlesHomeV2Content on Content {\n  __isContent: __typename\n  entityId\n  ...topStoriesItemV2Content\n}\n\nfragment heroSecondaryArticlesHomeV2QueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryV2ContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment heroThreeArticlesQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment homeFocusContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ... on Video {\n    duration\n  }\n  ...hooksContentItemProvidersContent_Q7hCx\n}\n\nfragment homeHeroArticleContentItemContent on Article {\n  entityId\n  urlAlias\n  moreOnThisArticles {\n    entityId\n    urlAlias\n    ...contentHeadlineContent\n    ...entityLink\n    id\n  }\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...contentTopicLinkContent\n  ...entityLink\n  ...hooksContentItemProvidersContent_BUyzk\n}\n\nfragment homeLatestContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_22ZBVY\n  ... on Video {\n    duration\n  }\n}\n\nfragment homeLatestV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3onApn\n}\n\nfragment homeNativeArticleContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2Mm1vQ\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3LgACx\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment homeSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  flag\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersCheckIsPlusArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_4u1L24\n}\n\nfragment homeStoryPackageLeadContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_17LfcA\n}\n\nfragment homeStoryPackageTailContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_101wKc\n}\n\nfragment homeSuperSplashLargePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_183JXa\n}\n\nfragment homeSuperSplashLivePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_183JXa\n}\n\nfragment homeSuperSplashLiveSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_101wKc\n}\n\nfragment homeThingsToDoV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_iSR0J\n}\n\nfragment homeV2FlexiUnitContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ...hooksContentItemProvidersContent_1Tvcel\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_101wKc on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_13FlZp on Content {\n  __isContent: __typename\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_17LfcA on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2Ihffa\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_183JXa on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSubHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1Tvcel on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1lYPqc on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_22ZBVY on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2Mm1vQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2RX0zR on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3LgACx on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3V3HsH on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1mXwiv\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3onApn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_4u1L24 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_BUyzk on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Q7hCx on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_wy32c\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_iSR0J on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1pemU3\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksHomeStoryPackageTopicQueue on Queue {\n  refTerms {\n    __typename\n    ... on Newsletter {\n      name\n      latestArticleLink\n      __typename\n    }\n    ... on Section {\n      name\n      ...entityLink\n      ...followButtonBase\n      ...sectionTermLogoSection\n      __typename\n    }\n    ... on Topic {\n      name\n      ...entityLink\n      ...followButtonBase\n      ...topicTermLogoTopic\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  settings\n}\n\nfragment hooksHomeV2PickMorningStudioArticle on Queue {\n  items(first: 9) {\n    edges {\n      node {\n        __typename\n        ...homeNativeArticleContentItemContent\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ...v2RecommendedForYouSponsorArticleQueueItemsEdge\n    }\n  }\n}\n\nfragment hooksHomeV2StoryPackageTopicQueue on Queue {\n  refTerms {\n    __typename\n    ... on Newsletter {\n      name\n      __typename\n    }\n    ... on Section {\n      name\n      ...entityLink\n      __typename\n    }\n    ... on Topic {\n      name\n      ...entityLink\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  settings\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksNewsAgendaTopic on Topic {\n  newsAgenda {\n    startDate\n    endDate\n    time\n    newsAgendaOptions\n  }\n}\n\nfragment hooksPickMorningStudioArticle on Queue {\n  items(first: 9) {\n    edges {\n      node {\n        __typename\n        ...aiArticleListSponsoredArticle\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ...topStoriesQueueItemsEdge\n    }\n  }\n}\n\nfragment hooksPlusArticleLinkHandlerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  id\n  entityId\n  urlAlias\n}\n\nfragment hooksPlusWidgetConfigQuery on Query {\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n  }\n}\n\nfragment hooksPremiumNativeAdConfigQuery on Query {\n  advertConfig: appConfig(filter: {entityId: \"scmp_pwa_advert_campaign\"}) {\n    json\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment itemAgendaItemTopic on Topic {\n  urlAlias\n  newsAgenda {\n    startDate\n  }\n  entityId\n  name\n  ...contentAgendaContentTopic\n  ...hooksNewsAgendaTopic\n}\n\nfragment latestContentsHomeV2Query_2HMWA1 on Query {\n  latestV2Contents: contents(articleExcludeInput: {articleTypeIds: $latestExcludeArticleTypes, paywallTypeIds: $scmpPlusPaywallTypeIds}, articleFilterInput: {sponsorTypes: [NONE]}, contentTypes: [ARTICLE, GALLERY, VIDEO], exclude: {sectionIds: $latestExcludeSectionIds}, first: 5, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...homeLatestV2ContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment latestContentsQuery_2HMWA1 on Query {\n  contents(contentTypes: [ARTICLE, GALLERY, VIDEO], first: 6, exclude: {sectionIds: $latestExcludeSectionIds}, articleExcludeInput: {articleTypeIds: $latestExcludeArticleTypes, paywallTypeIds: $scmpPlusPaywallTypeIds}, articleFilterInput: {sponsorTypes: [NONE]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...homeLatestContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment opinionHomeV2QueueQuery_pwKp9 on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    id\n  }\n  opinionQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentV2ContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  harryContents: contents(contentTypes: [GALLERY], first: 1, filter: {sectionIds: $commentHarrySectionIds}, articleExcludeInput: {paywallTypeIds: $scmpPlusPaywallTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        entityId\n        ...harryContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusWidgetArticleHomeV2 on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_1lYPqc\n}\n\nfragment plusWidgetDailyPulseQuery_3abQBm on Query {\n  dailyPulseQuery: articles(filter: {typeIds: [$dailyPulseTypeUuId]}, first: 1, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        urlAlias\n        ...entityLink\n        ...contentHeadlineContent\n        ...hooksArticleDateUtilsContent\n        ...hooksPlusArticleLinkHandlerArticle\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetHasAccessQuery_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment plusWidgetHighlight on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersGetArticleTypeArticle\n  ...hooksContentItemProvidersContent_2Mm1vQ\n  ...plusArticleTypeTitleContent\n}\n\nfragment plusWidgetHighlightsQuery_3iQMXB on Query {\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    items(first: 2) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...plusWidgetHighlight\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment plusWidgetHomeV2Query on Query {\n  dailyPulseArticles: articles(filter: {typeIds: [\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}, first: 1) {\n    edges {\n      node {\n        entityId\n        ...plusWidgetArticleHomeV2\n        id\n      }\n    }\n  }\n  plusArticles: articles(filter: {paywallTypeIds: [\"716f570e-3083-4138-a080-47d3830fafe3\"]}, exclude: {typeIds: [\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}, first: 2) {\n    edges {\n      node {\n        entityId\n        ...plusWidgetArticleHomeV2\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetNewsAgendaQuery_3kWRW2 on Query {\n  topics(first: 5, applicationId: $applicationId, filter: {types: $plusNewsAgendaTypes, newsAgendaDateRange: {startDate: $plusNewsAgendaStartDate, endDate: $plusNewsAgendaEndDate}, newsAgendaOptions: [\"key_event\"]}, orderBy: {field: NEWS_AGENDA_START_DATE, direction: ASC}) {\n    edges {\n      node {\n        ...itemAgendaItemTopic\n        ...hooksNewsAgendaTopic\n        newsAgenda {\n          newsAgendaOptions\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetQuery_1YyBVf on Query {\n  ...plusWidgetWithoutAccess_1YyBVf\n  ...plusWidgetHasAccessQuery_1YyBVf\n  ...hooksPlusWidgetConfigQuery\n}\n\nfragment plusWidgetWithoutAccess_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment scmpShortsCard on Video {\n  entityId\n  headline\n  urlAlias\n  youtubeId\n  images {\n    portraitStyle: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n  ...entityLink\n}\n\nfragment scmpShortsHomeV2Query_3hK5ms on Query {\n  scmpShortsV2Queue: queue(filter: {name: $scmpShortsQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Video {\n            entityId\n            ...scmpShortsCard\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment secondaryStoryPackageHomeV2Query_1swAuP on Query {\n  secondaryStoryPackageV2Articles: queue(filter: {name: $secondaryStoryPackageArticlesQueueName}) {\n    ...hooksHomeV2StoryPackageTopicQueue\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...sectionStoryBlockHomeV2QueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment secondaryStoryPackageQuery_1swAuP on Query {\n  secondaryStoryPackageArticles: queue(filter: {name: $secondaryStoryPackageArticlesQueueName}) {\n    ...hooksHomeStoryPackageTopicQueue\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...topStoriesBlockQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStoryBlockHomeV2QueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      urlAlias\n      ...contentCoverImageContent_ScPJx\n      ...homeSecondaryV2ContentItemContent\n      ...entityLink\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment sectionTermLogoSection on Section {\n  name\n  sectionLogo: image(filter: {type: TERM_LOGO}) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment seriesWidgetHomeV2Query_iI4uX on Query {\n  seriesWidgetV2Articles: queue(filter: {name: $seriesWidgetArticlesQueueName}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            seriesShortLabel\n            series {\n              __typename\n              ... on Content {\n                __isContent: __typename\n                entityId\n                publishedDate\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            ...seriesWidgetTabContentHomeV2Article\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment seriesWidgetQuery_iI4uX on Query {\n  seriesWidgetArticles: queue(filter: {name: $seriesWidgetArticlesQueueName}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            seriesShortLabel\n            series {\n              __typename\n              ... on Content {\n                __isContent: __typename\n                entityId\n                publishedDate\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            ...seriesWidgetTabContentArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment seriesWidgetTabContentArticle on Article {\n  seriesShortLabel\n  entityId\n  urlAlias\n  ...entityLink\n  series {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      urlAlias\n      publishedDate\n      ...entityLink\n      ...contentCoverImageContent_34Njms\n      ...helpersCheckIsPlusArticle\n      ...helpersCheckHasLiveTagArticle\n      ...helpersUseContentSponsorContent\n      ...hooksContentItemProvidersContent_2gnGW2\n      ...homeSecondaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment seriesWidgetTabContentHomeV2Article on Article {\n  seriesShortLabel\n  entityId\n  urlAlias\n  ...entityLink\n  series {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      urlAlias\n      publishedDate\n      ...entityLink\n      ...homeSecondaryV2ContentItemContent\n      ...contentCoverImageContent_34Njms\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment spotlightHomeV2Query_Mf8QP on Query {\n  spotlightV2Queue: queue(filter: {name: $spotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...sectionStoryBlockHomeV2QueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment spotlightQuery_Mf8QP on Query {\n  spotlightQueue: queue(filter: {name: $spotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...topStoriesBlockQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment storyPackageQuery_1ZDJci on Query {\n  storyPackageArticles: queue(filter: {name: $storyPackageArticlesQueueName}) {\n    ...hooksHomeStoryPackageTopicQueue\n    items(first: 3) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...entityLink\n            ...homeStoryPackageLeadContentItemContent\n            ...homeStoryPackageTailContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment superSplashHomeV2Query_3oF9in on Query {\n  liveWidget(filter: {edition: $liveWidgetEditionEnumValue}, orderBy: {direction: DESC, field: UPDATED_DATE}) {\n    style\n    ...superSplashLiveLiveWidget\n    ...superSplashLargeLiveWidget\n    id\n  }\n}\n\nfragment superSplashLargeLiveWidget on LiveWidget {\n  label\n  description\n  relatedArticles {\n    ...homeSuperSplashLargePrimaryContentItemContent\n    ...homeSuperSplashLiveSecondaryContentItemContent\n    id\n  }\n}\n\nfragment superSplashLiveLiveWidget on LiveWidget {\n  label\n  relatedArticles {\n    entityUuid\n    urlAlias\n    ...homeSuperSplashLivePrimaryContentItemContent\n    ...homeSuperSplashLiveSecondaryContentItemContent\n    id\n  }\n}\n\nfragment superSplashQuery_3oF9in on Query {\n  liveWidget(filter: {edition: $liveWidgetEditionEnumValue}, orderBy: {direction: DESC, field: UPDATED_DATE}) {\n    style\n    ...superSplashLiveLiveWidget\n    ...superSplashLargeLiveWidget\n    id\n  }\n}\n\nfragment thingsToDoHomeV2Query on Query {\n  thingToDoV2Queue: queue(filter: {name: \"homepage_service_journalism_hk\"}) {\n    settings\n    items(first: 3) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeThingsToDoV2ContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment thingsToDoQueue on Query {\n  thingToDoQueue: queue(filter: {name: \"homepage_service_journalism_hk\"}) {\n    settings\n    items(first: 3) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment topStoriesBlockQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...topStoriesItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesHomeV2QueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryV2ContentItemContent\n      ...topStoriesItemV2Content\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topStoriesItemV2Content on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n  ...homeSecondaryV2ContentItemContent\n}\n\nfragment topStoriesQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...topStoriesBlockQueueItemsEdge\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment topicTermLogoTopic on Topic {\n  name\n  image(type: TERM_LOGO) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment v2RecommendedForYouSponsorArticleQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeNativeArticleContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dbc29159c638fb3add06321a32e58cca";

export default node;
